import { render, staticRenderFns } from "./BatchSamplesBatchConfirmation.vue?vue&type=template&id=9eb478d6&scoped=true"
import script from "./BatchSamplesBatchConfirmation.vue?vue&type=script&lang=js"
export * from "./BatchSamplesBatchConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BatchSamplesBatchConfirmation.vue?vue&type=style&index=0&id=9eb478d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb478d6",
  null
  
)

export default component.exports